module.exports = __webpack_public_path__ + "static/media/notifications_white.3e372065.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/notifications_white.svg
// module id = 18
// module chunks = 0